import { ComponentRef, Injectable } from '@angular/core';
import { AchooModalDialogComponent } from './achoo-modal-dialog.component';

@Injectable()
export class AchooModalDialogInstanceService {
    /**
     * Used to make sure there is exactly one instance of Modal Dialog
     */
    private componentRef: ComponentRef<AchooModalDialogComponent>;

    /**
     * Closes existing modal dialog
     */
    closeAnyExistingModalDialog() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    /**
     * Save component ref for future comparison
     * @param componentRef
     */
    saveExistingModalDialog(componentRef: ComponentRef<AchooModalDialogComponent>) {
        this.componentRef = componentRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-modal-dialog/achoo-modal-dialog-instance.service.ts